package one.healthium.med.presentation.navigation.today

import com.arkivanov.decompose.ComponentContext

class DefaultTodayComponent(
    componentContext: ComponentContext,
    private val onMealPlanClicked: (String) -> Unit,
    private val onLogFoodClicked: () -> Unit,
    private val onLogWaterClicked: () -> Unit,
    private val onLogWeightClicked: () -> Unit,
    private val onLogSymptomsClicked: () -> Unit,
) : TodayComponent, ComponentContext by componentContext {
    override fun onMealPlanClicked(id: String) {
        onMealPlanClicked.invoke(id)
    }

    override fun onLogFoodClicked() {
        onLogFoodClicked.invoke()
    }

    override fun onLogWaterClicked() {
        onLogWaterClicked.invoke()
    }

    override fun onLogWeightClicked() {
        onLogWeightClicked.invoke()
    }

    override fun onLogSymptomsClicked() {
        onLogSymptomsClicked.invoke()
    }
}
